import { render, staticRenderFns } from "./uploadOneMedia.vue?vue&type=template&id=dbb125ae&scoped=true"
import script from "./uploadOneMedia.vue?vue&type=script&lang=js"
export * from "./uploadOneMedia.vue?vue&type=script&lang=js"
import style0 from "./uploadOneMedia.vue?vue&type=style&index=0&id=dbb125ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb125ae",
  null
  
)

export default component.exports